import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})

export class DocumentationService {
  protected baseUrl = AppSettingsService.appSettings.DocumentationAPIUrl;
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };

  constructor(private http: HttpClient) { }

  getDocumentation(path: any) {
    return this.http.post(this.baseUrl + "/documentation/getPage", path, this.options);
  }

}
